import { CHECKOUT_ITEM_TYPE_TOUR_V2 } from 'constants/checkout'
import { dateDifference } from 'lib/datetime/dateUtils'
import uuidV4 from 'lib/string/uuidV4Utils'

function findPurchasableOption(offer: Tours.V2Offer, selectedDeparture: Tours.V2OfferDeparture) {
  return offer.purchasableOptions.find(opt => {
    return (opt.fkDepartureId === selectedDeparture.id) &&
      (opt.fkSeasonId === selectedDeparture.fkSeasonId) &&
      (opt.fkVariationId === selectedDeparture.fkVariationId)
  })
}

function generatePartialTourV2CheckoutItems(
  offer: Tours.V2Offer,
  selectedDeparture: Tours.V2OfferDeparture,
  image: App.Image,
  selectableOccupancies: App.Occupants[],
): App.Checkout.TourV2Item[] {
  const { startDate, endDate } = selectedDeparture
  const { days } = dateDifference(new Date(endDate), new Date(startDate))

  const purchasableOption = findPurchasableOption(offer, selectedDeparture) || {
    fkDepartureId: selectedDeparture.id,
    fkSeasonId: selectedDeparture.fkSeasonId,
    fkTourId: offer.id,
    fkVariationId: selectedDeparture.fkVariationId,
    fullPrice: 0,
    price: 0,
  }
  return selectableOccupancies.map(occupancy => {
    return {
      startDate,
      endDate,
      occupancy,
      image,
      purchasableOption,
      offerId: offer.id,
      duration: days + 1,
      itemId: uuidV4(),
      itemType: CHECKOUT_ITEM_TYPE_TOUR_V2,
      transactionKey: uuidV4(),
      privateRequestKey: offer.privateRequestKey,
      total: purchasableOption.price * occupancy.adults,
      purchasableOptionConfirmed: false,
    }
  })
}

export default generatePartialTourV2CheckoutItems
